import React from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {Alert, Space} from 'antd';
import {Link} from 'react-router-dom';
import {QuestionCircleFilled} from '@ant-design/icons';
import {StyledDeleteCardModal,} from './StyledDeleteCardModal';
import TrashIcon from '../../../../icons/TrashIcon';
import routes from '../../../../routes/routes.json';

const DeleteCardModal = ({
  cardNumber,
  open,
  loading = false,
  ...rest
}) => {
  const [t] = useTranslation(['main', 'cards']);

  const trans = (key, options) => t(`cards:modal.delete.${key}`, options);

  const alertErrorMessage = (
    <>
      {trans('error1')}
      &nbsp;
      <Link to={routes.support}>
        <QuestionCircleFilled /> {t('section')}
      </Link>
      &nbsp;
      {trans('error2')}
    </>
  );

  return (
    <StyledDeleteCardModal
      open={open}
      okText={t('delete')}
      loading={loading}
      cancelButtonProps={{size: 'large'}}
      okButtonProps={{loading, type: 'primary', size: 'large'}}
      width={420}
      title={trans('title')}
      {...rest}
    >
      <Space
        align='center'
        direction='vertical'
        size={10}
      >
        <TrashIcon />
        <span>{trans('question', {number: cardNumber})}</span>
        <Alert message={alertErrorMessage} type='warning' showIcon />
      </Space>
    </StyledDeleteCardModal>
  );
}

DeleteCardModal.propTypes = {
  cardNumber: PropTypes.string,
  open: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
}

export default DeleteCardModal;
